var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.8L3.66666 8.46667C3.40666 8.20667 2.99333 8.20667 2.73333 8.46667C2.47333 8.72667 2.47333 9.14 2.73333 9.4L5.52666 12.1933C5.78666 12.4533 6.20666 12.4533 6.46666 12.1933L13.5333 5.13334C13.7933 4.87334 13.7933 4.46 13.5333 4.2C13.2733 3.94 12.86 3.94 12.6 4.2L6 10.8Z",
    fill: "#00BA88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.55cf778712249c4a9794044b8bfefa25.svg";
export { ForwardRef as ReactComponent };